export default __webpack_public_path__ + "static/media/Accounts-depart.cdc22643.jpg";